import { File as FileInterface, HttpClient } from '../FilePicker';

export const defineFilesState = (reduxFormValue, defaultFiles, files, value) => {
  return reduxFormValue || value || files || defaultFiles || [];
};

export const getRequests = (files: Array<File & FileInterface>, httpClient: HttpClient, url: string) =>
  files
    .filter(file => !file.pk)
    .map(file => {
      const fileData = new FormData();
      fileData.append(file.name, file);
      return httpClient.post(url, fileData);
    });
